<template>
	<div class="material number" v-bind:class="{
		'focus': focus,
		'has-value': !! input || input === '0',
	}">
		<div class="label">{{ label }} {{ unit }}</div>
		<input
			:disabled="disabled"
			type="number"
			v-model="input"
			v-on:keyup.esc="$emit('esc')"
			v-on:keyup.enter="$emit('enter')"
			v-on:focus="focus = true;"
			v-on:blur="focus = false;" />
	</div>
</template>

<script>
export default {
  props: [
    'value',
    'label',
    'unit',
    'disabled'
  ],
  data: () => ({
    focus: false
  }),
  computed: {
    input: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('change', {
          old: this.value,
          new: value
        })
        this.$emit('input', value)
      }
    }
  }
}
</script>
